import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import React from 'react'
import style from './style.module.less'

const getItemValue = (item, store) => {
  const { value, options, type, unit } = item
  switch (type) {
    case 'radio':
    case 'select':
      const info = options.find(el => el.id == value)
      if (value && !info) {
        item.value = ''
      }
      return <div className={style.itemText}>{info ? info.title : ''}</div>
    case 'input':
    case 'inputLimit':
    case 'inputNumber':
      return (
        <div className={style.itemText}>
          {value}
          {value !== undefined && value !== '' ? unit : undefined}
        </div>
      )
    case 'textArea':
      return <div className={style.itemTextArea}>{value}</div>
    case 'precisionInput':
      return (
        <div className={style.itemText}>
          {value}
          {value !== undefined && value !== '' ? unit : undefined}
        </div>
      )

    case 'inputInterval':
      const { age_begin, age_end } = store
      return (
        <div className={style.itemText}>
          {age_begin} {age_begin && age_end ? '-' : null} {age_end}
        </div>
      )
    case 'checkBox':
      const checkBoxData =
        Object.prototype.toString.call(toJS(value)) === '[object Array]' &&
        value.map(item => options.find(el => el.id + '' === item + ''))
      const checkBoxText =
        checkBoxData &&
        checkBoxData.reduce((pre, curr) => {
          if (curr) {
            return pre + curr.title + ' '
          }
          return pre
        }, '')

      return <div className={style.itemText}>{checkBoxText}</div>
    case 'selectInput':
      const data =
        value &&
        value.map((curr, currIndex) => {
          const text = options.find(el => el.id == curr.id)
          return text ? (
            <div key={currIndex} className={style.itemText}>
              {text.title}：{curr.extra}
            </div>
          ) : null
        })
      return <div className={style.itemText}>{data}</div>
    case 'doubleInput':
      const doubleInputData =
        value &&
        value.map((curr = {}, currIndex) => {
          return (
            <div key={currIndex} className={style.itemText}>
              {curr.title}: {curr.extra}
            </div>
          )
        })
      return <div className={style.itemText}>{doubleInputData}</div>
    case 'radioInput':
      let radioInput
      if (value) {
        if (value.id) {
          radioInput =
            value && value.id && options.find(el => el.id == value.id)
        } else {
          radioInput = value && options.find(el => el.id == value)
        }
      }
      return (
        <div className={style.itemText}>
          {radioInput ? radioInput.title : value ? value.title : ''}
        </div>
      )
    case 'lvpai_itinerary':
      const { itineraryList } = store
      return (
        <div style={{ width: '100%' }}>
          {itineraryList.map(
            (el, index) =>
              el && (
                <div key={index} className={style.travelBox}>
                  <div className={style.travelLabel}>行程{index + 1}</div>
                  <div className={style.content}>{el?.describe}</div>
                  <ul className={style.images}>
                    {el?.spots?.map(el => (
                      <li className={style.imgItem} key={el.id}>
                        <img src={el.cover} alt={el.name} />
                        <span className={style.tag}>{el.name}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )
          )}
        </div>
      )
    default:
      return <div className={style.itemText}>{value}</div>
  }
}

export default observer(props => {
  const {
    data: { text, childNodes, required },
    store,
    styles
  } = props

  return (
    <div className={style.item} style={{ ...styles }}>
      {required ? (
        <p className={style.itemTitleRequired}>
          <img
            className={style.labelStar}
            src="//qnm.hunliji.com/o_1d21but2psea1tel1cdf1g6njme9.png"
          />
          <span>{text}</span>
        </p>
      ) : (
        <p className={style.itemTitle}>
          <img
            className={style.labelStar}
            src="//qnm.hunliji.com/o_1d21but2psea1tel1cdf1g6njme9.png"
          />
          <span>{text}</span>
        </p>
      )}
      {childNodes.map(
        (item, index) =>
          item.disabled ? null : (
            <div key={index} className={style.childNodes}>
              {item.text && <div className={style.itemLabel}>{item.text}</div>}
              {getItemValue(item, store)}
            </div>
          )
      )}
    </div>
  )
})
